import { render } from "./LoginModal.vue?vue&type=template&id=a96c1bba&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=a96c1bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96c1bba"]])

export default __exports__